import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';

import { JSX } from 'react';
import { RateCalculatorInner } from './RateCalculatorInner/RateCalculatorInner';

export type RateCalculatorProps =
  SliceComponentProps<Content.RateCalculatorSlice>;

const RateCalculator = ({ slice }: RateCalculatorProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <RateCalculatorInner data={slice.primary} />
    </section>
  );
};

export default RateCalculator;
